import { Store as u } from "@tanstack/store";
const r = Symbol("originalFactory");
function a(n) {
  if (typeof n == "object" && "key" in n)
    return function t() {
      return n[r] = t, n;
    };
  if (typeof n != "function")
    throw new Error("factory must be a function");
  return function t(e) {
    return (i) => {
      const o = n({ editor: i.editor, options: e });
      return o[r] = t, o;
    };
  };
}
function f(n, t) {
  return new u(n, t);
}
export {
  f as a,
  a as c,
  r as o
};
//# sourceMappingURL=BlockNoteExtension-C2X7LW-V.js.map
